import { useState, useEffect } from "react"
import { Form } from "react-bootstrap"

const SingupSelectInput = (props) => {
  const {
    name,
    validTest,
    setValid,
    isValid,
    setValue,
    blurAll,
    ...inputProps
  } = props

  const [isTouched, setIsTouched] = useState(false)

  const handleOnChange = (e) => {
    setValue(e.target.value)
    setValid(name, validTest(e.target.value))
  }

  const handleOnBlur = (e) => {
    setIsTouched(true)
    setValid(name, validTest(e.target.value))
  }

  useEffect(() => {
      if (blurAll) {
        setIsTouched(true)
      }
    }, [blurAll])

  return (
    <Form.Group className="mb-2" controlId={name}>
      <Form.Select
        onBlur={handleOnBlur}
        isInvalid={!isValid && isTouched}
        onChange={handleOnChange}
        {...inputProps}
      >
        <option value="">Select Account Type</option>
        <option value="gymnast">Gymnast</option>
        <option value="assistant">Assistant Coach</option>
        <option value="coach">Coach</option>
        <option value="director">Director</option>
      </Form.Select>
      <Form.Control.Feedback type="invalid" className="fw-semibold">
        <i>Please select a valid account type</i>
      </Form.Control.Feedback>
    </Form.Group>
  )
}
export default SingupSelectInput